import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { ExchangeRateKey } from 'api/Clients/Types/ExchangeRate'

export interface GridColumn extends GridColumnProps {
  fields?: string[]
  exportFn?(gridProps: GridCellProps): string
  show: boolean
  width?: number
}

export const currencyMarkupColumns: GridColumn[] = [
  {
    title: 'From',
    field: ExchangeRateKey.baseCurrency,
    show: true,
    filterable: true,
    sortable: false,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'To',
    field: ExchangeRateKey.quoteCurrency,
    show: true,
    filterable: true,
    sortable: false,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'Original Rate',
    field: ExchangeRateKey.originalRate,
    show: true,
    filterable: true,
    sortable: false,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'Deposit Rate Including Markup',
    field: ExchangeRateKey.rate,
    show: true,
    filterable: true,
    sortable: false,
    className: 'table-columns__content',
    filter: 'text',
  },

  {
    title: 'Withdrawal Rate Including Markup',
    field: ExchangeRateKey.withdrawalRate,
    show: true,
    filterable: true,
    sortable: false,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'New Deposit Rate',
    field: ExchangeRateKey.newDepositRate,
    show: true,
    filterable: true,
    editable: true,
    sortable: false,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'New Withdrawal Rate',
    field: ExchangeRateKey.newWithdrawalRate,
    show: true,
    filterable: true,
    editable: true,
    sortable: false,
    className: 'table-columns__content',
    filter: 'text',
  },
]
